<div ngbDropdown [ngClass]="{
  '3xl:tw-hidden': viewMode === 'default',
  'tw-flex': viewMode === 'default' || viewMode == 'dropdown',
  'tw-hidden': viewMode == 'row'
  }">
  <sb-button classes="btn-hover-primary d-flex align-items-center mr-1" ngbDropdownToggle>
    <div style="line-height: 1.46rem;">
      <ng-container *ngFor="let toggle of toggles">
        <sb-icon [ngClass]="toggle.value ? toggle.classPreview : ''" class="singleEllipsis-h"
                 icon="circleFilled"></sb-icon>
      </ng-container>
    </div>
    <sb-icon class="ml-2 d-none d-sm-inline-flex" style="" icon="chevronDown"></sb-icon>
  </sb-button>
  <div ngbDropdownMenu>
    <ul class="dropdown">
      <li class="head">
        <ng-content></ng-content>
      </li>
      <li class="separator"></li>
      <li class="item" *ngFor="let toggle of toggles">
        <a class="item-link">
          <div class="form-check form-switch mr-3" [ngClass]="toggle.class">
            <input type="checkbox" role="switch" class="form-check-input" [id]="'sw' + toggle.id + '-dm'"
                   [(ngModel)]="toggle.value" (ngModelChange)="onToggleChange(toggle.id, $event)">
            <label class="form-check-label" [for]="'sw' + toggle.id + '-dm'">
              <ng-container *ngIf="translateLabels; else labelNoTranslation">
                {{ toggle.name | translate }}
              </ng-container>
              <ng-template #labelNoTranslation>
                {{ toggle.name }}
              </ng-template>
            </label>
          </div>
        </a>
      </li>
    </ul>
  </div>
</div>
<div class="mr-1" style="flex: 1;" [ngClass]="{
  '3xl:tw-flex': viewMode === 'default',
  'tw-hidden': viewMode === 'default' || viewMode == 'dropdown',
  'tw-flex': viewMode == 'row'
  }">
  <ng-container *ngFor="let toggle of toggles">
    <div class="form-check form-switch mr-3" [ngClass]="toggle.class">
      <input type="checkbox" role="switch" class="form-check-input" [id]="'sw' + toggle.id" [(ngModel)]="toggle.value"
             (ngModelChange)="onToggleChange(toggle.id, $event)">
      <label class="form-check-label" [for]="'sw' + toggle.id">
        <ng-container *ngIf="translateLabels; else labelNoTranslation">
          {{ toggle.name | translate }}
        </ng-container>
        <ng-template #labelNoTranslation>
          {{ toggle.name }}
        </ng-template>
      </label>
    </div>
  </ng-container>
</div>

<div class="tw-hidden" [ngClass]="{
  'tw-hidden': false
  }">
</div>
